<script setup lang="ts">
  import { useRoute } from 'vue-router';

  import Checkout from '@/components/Checkout.vue';

  definePage({ name: 'invoice-checkout' });

  const route = useRoute();
  //@ts-ignore
  const invoiceIds = route.params.invoiceIds.split(',');
</script>

<template>
  <Checkout :invoice-ids />
</template>
